import { PayloadAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import {
  getAppSetting as _getAppSetting
} from 'services/appService'
interface AppState {
  app_id: string;
  setting: {
    logo_url: string,
    law_file_url: string,
    privacy_file_url: string,
    term_file_url: string,
    copyright: string,
    app_name: string,
    appstore_url: string,
    googleplay_url: string,
    login_url: string,
    os_type: number[]
  }
}

const initialState: AppState = {
  app_id: '',
  setting: {
    logo_url: '',
    law_file_url: '',
    privacy_file_url: '',
    term_file_url: '',
    copyright: '',
    app_name: '',
    appstore_url: '',
    googleplay_url: '',
    login_url: '',
    os_type: []
  }
}

export const getAppSetting = createAsyncThunk(
  'getAppSetting',
  async (app_id: string, { rejectWithValue }) => {
    try {
      const data = await _getAppSetting({ app_id })
      return data.data
    } catch (err: any) {
      return rejectWithValue(err)
    }
  }
)

export const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    setAppData: (state, action: PayloadAction<AppState>) => {
      state = action.payload
    },
    setAppId: (state, action: PayloadAction<string>) => {
      state.app_id = action.payload
    },
    setAppSetting: (state: { setting: any; }, action: { payload: any; }) => {
      state.setting = action.payload
    }
  },
  extraReducers: (builder) => {
    builder.addCase(getAppSetting.fulfilled, (state: { setting: any; }, action: { payload: any; }) => {
      state.setting = action.payload
    })
  }
})
export const { setAppData, setAppId, setAppSetting } = appSlice.actions

export default appSlice.reducer
